export class ShapeStyle {
  // Marker Color must exist in leflet.extramarkers.d.ts#markerColor
  // https://github.com/coryasilva/Leaflet.ExtraMarkers?tab=readme-ov-file#properties
  constructor(
    public readonly markerColor: string,
    public readonly lineColor: string,
    public readonly lineWeight: number,
    public readonly pane: string
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/shapestyle.model.ts